module.exports = "/call-frontend/img/icon_cancel_outline_white.935b6487.svg";